import type { RecallAgentSettings } from './types';

/**
 * The page's one setting, plus the live count its footer shows.
 *
 * The link strip's `{total}` and `{running}` are **not here on purpose** — they
 * are derived from the same recall list `/recall` renders, because the whole
 * complaint was that this page said 6 while the list said something else.
 */
export const RECALL_AGENT: RecallAgentSettings = {
  deadlineOpenDays: 5,
  callsWaiting: 7,
};
